/**
 * The brief identity a PDP image-set picker widget carries so it can offer the
 * "From brief: <title>" button and the drawer behind it. (POR-13996)
 *
 * Read off parsedPrompt rather than passed in by each caller, because a session
 * staged from a brief re-emits the picker from several places (add a product,
 * submit a reference, edit the set) — sourcing it from session state keeps the
 * button on every one of them, and off pickers that have nothing to do with a
 * brief.
 *
 * Lives in its own module (no imports) so the picker-emitting handlers and
 * brief-handoff.js can all use it without an import cycle.
 *
 * @param {object} adapter — CS adapter (getParsedPrompt)
 * @returns {{briefId: string|number|null, briefTitle: string}}
 */
export function briefWidgetFields(adapter) {
  const parsed = (adapter && adapter.getParsedPrompt && adapter.getParsedPrompt()) || {};

  return {
    briefId: parsed.activeBriefId || null,
    briefTitle: parsed.activeBriefTitle || '',
  };
}
